

































































import { Component,	Vue, Prop, Watch } from 'vue-property-decorator';

import { bus } from '@/main'

@Component
export default class AppInfo extends Vue {
	@Prop({ required: true }) openScreen!: string | false

	openInfoScreens: string[] = []
	infoOpening: boolean = true

	get navigatedFarEnough(): boolean {
		return !(this.trimmedRouteName === 'home' || this.trimmedRouteName === 'select-age' || this.trimmedRouteName === 'select-branch' || this.trimmedRouteName === 'criminal-record' || this.trimmedRouteName === 'select-crime' || this.trimmedRouteName === 'select-punishment')
	}

	toggleInfoScreen(screen: string, screenTitle: string): void {
		this.openInfoScreens.indexOf(screen) !== -1 ? this.openInfoScreens.splice(this.openInfoScreens.indexOf(screen), 1) : this.openInfoScreens.push(screen)

		if (this.openInfoScreens.indexOf(screen) !== -1) {
			_paq.push(['trackEvent', 'infoSchermGeopend', screenTitle])
		}
	}
	infoScreens(getTop: boolean | 'all'): { [key: number]: { screen: string, title: string, ageSensitiveText?: boolean, text: string | { '<23' : string, '23+' : string }}, topOfInfo?: boolean } {
		let infoScreens = this.$store.getters.infoScreens
		let infoOfCurrentScreen = null

		;[...infoScreens].forEach((infoScreen: any, index: number) => {
			infoScreen.topOfInfo = false

			if (infoScreen.screen === this.$route.name || infoScreen.screen === this.trimmedRouteName) {
				infoScreen.topOfInfo = true
			} else if (this.openScreen && infoScreen.screen === this.openScreen) {
				infoScreen.topOfInfo = true
			}
		})
		
		infoScreens = [...infoScreens].filter((infoScreen: { screen: string, title: string, ageSensitiveText?: boolean, text: string | { '<23' : string, '23+' : string }}) => {
			if (infoScreen.screen === 'punishment-when' || infoScreen.screen === 'punishment-length' || infoScreen.screen === 'crime-when' || infoScreen.screen === 'crime-when-alt') {
				if (this.$store.getters.user.selectedPunishment && this.navigatedFarEnough) {
					if (this.$store.getters.user.selectedPunishment === 'detention' || this.$store.getters.user.selectedPunishment === 'tbs/pij') {
						return (infoScreen.screen === 'punishment-when' || infoScreen.screen === 'punishment-length')
					} else {
						return infoScreen.screen === 'crime-when'
					}
				} else {
					return false
				}
			} else {
				return true
			}
		})

		if (getTop !== 'all') {
			infoScreens = infoScreens.filter((infoScreen: any) => {
				return infoScreen.topOfInfo === getTop
			})
		}

		return infoScreens
	}
	closeInfo(): void {
		bus.$emit('closeInfo')
		this.infoOpening = true;
	}
	
	closeInfoOnClickOutside() {
		if (!this.infoOpening) {
			this.closeInfo();
		}
	}

	get trimmedRouteName(): string {
		const lastIndex = this.$route.name!.lastIndexOf('-')
		if(lastIndex === -1) {
			return this.$route.name!
		}
		return this.$route.name!.slice(0, lastIndex)
	}

	mounted() {
		// focus on close button at the top	
		this.$nextTick(() => {
			(this.$el.children[0].firstChild as HTMLElement).focus();
		})
		
		setTimeout(() => {
			[...(<any>this.infoScreens('all'))].forEach((item: any) => {
				if (this.$route.name === item.screen || this.trimmedRouteName === item.screen) {
					this.toggleInfoScreen(item.screen, item.title)
				} else if (item.screen === this.openScreen) {
					this.toggleInfoScreen(item.screen, item.title)
				}
			})
		}, 1)

		setTimeout(() => {
			this.infoOpening = false
		}, 400)

		window.addEventListener('keyup', e => {
			if (e.keyCode === 27) {
				this.closeInfo()
			}
		})
		
		window.addEventListener('click', this.closeInfoOnClickOutside)

		this.$el.addEventListener('click', e => {
			e.stopPropagation()
		})
	}

	beforeDestroy() {
		window.removeEventListener('click', this.closeInfoOnClickOutside)
	}

	get pageTexts(): any {
		return this.$store.getters.pageTexts
	}
}
